/*****
 * Created by Allan on 2021/10/20.
 * Contact 84880528@qq.com.
 * *****/
import Http from '@/services/http/'
import user from '@/store/user'
export default{
    state:{
        paymentChannelInfos:JSON.parse(localStorage.getItem('paymentChannelInfos')),  //还款渠道信息
        payoutChannelInfos:JSON.parse(localStorage.getItem('payoutChannelInfos')),  //放款渠道信息
        modifyPayNum:localStorage.getItem('modifyPayNum') || 0,  //修改次数
        payOperateParams:JSON.parse(localStorage.getItem('payOperateParams')),  //修改传参
        nowPassageway:JSON.parse(localStorage.getItem('nowPassageway')),  //现有收款通道数据
        addPassageway:JSON.parse(localStorage.getItem('addPassageway')),  //添加收款通道数据

        nowPayoutPassageway:JSON.parse(localStorage.getItem('nowPayoutPassageway')),
        addPayoutPassageway:JSON.parse(localStorage.getItem('addPayoutPassageway')),

    },
    //Getter 接受 state 作为其第一个参数,可以接受其他 getter 作为第二个参数
    getters:{
        paymentChannelInfos:state=>state.paymentChannelInfos,
        payoutChannelInfos:state=>state.payoutChannelInfos,
        modifyPayNum:state=>state.modifyPayNum,
        payOperateParams:state=>state.payOperateParams,
        nowPassageway:state=>state.nowPassageway,
        addPassageway:state=>state.addPassageway,

        nowPayoutPassageway:state=>state.nowPayoutPassageway,
        addPayoutPassageway:state=>state.addPayoutPassageway,

    },
    //state 作为第一个参数
    mutations:{
        setPaymentChannelInfos(state,data){
            localStorage.setItem('paymentChannelInfos',JSON.stringify(data));
            state.paymentChannelInfos=data;
        },
        setPayoutChannelInfos(state,data){
            localStorage.setItem('payoutChannelInfos',JSON.stringify(data));
            state.payoutChannelInfos=data;
        },
        setModifyPayNum(state,data){
            localStorage.setItem('modifyPayNum',data);
            state.modifyPayNum=data;
        },
        setPayOperateParams(state,data){
            localStorage.setItem('payOperateParams',JSON.stringify(data));
            state.payOperateParams=data;
        },
        setNowPassageway(state,data){
            localStorage.setItem('nowPassageway',JSON.stringify(data));
            state.nowPassageway=data;
        },
        setAddPassageway(state,data){
            localStorage.setItem('addPassageway',JSON.stringify(data));
            state.addPassageway=data;
        },

        setNowPayoutPassageway(state,data){
            localStorage.setItem('nowPayoutPassageway',JSON.stringify(data));
            state.nowPayoutPassageway=data;
        },
        setAddPayoutPassageway(state,data){
            localStorage.setItem('addPayoutPassageway',JSON.stringify(data));
            state.addPayoutPassageway=data;
        },

        deletePassageway(state,data){
            localStorage.removeItem('nowPassageway');
            localStorage.removeItem('addPassageway');
            state.addPassageway='';
            state.nowPassageway='';

            localStorage.removeItem('nowPayoutPassageway');
            localStorage.removeItem('addPayoutPassageway');
            state.addPayoutPassageway='';
            state.nowPayoutPassageway='';

        },
    },
    //Action 提交的是 mutation，而不是直接变更状态
    actions:{
        mxPayoutPaymentChannels({commit},data){
            return new Promise((resolve,reject)=>{
                Http('/product/mxPayoutPaymentChannels',{method:'post',data:{},reqType:'json'}).then(res=>{
                    console.log('product/mxPayoutPaymentChannels',res)
                    //const colors=['#0091FF','#e83aaf','#23a274','#5378f6','#ff1414','#6DD400','#F7B500','#FF6161','#00e67e'];
                    const colors=['#0091FF','#00B6FF','#00D1EC','#32837E','#002A83','#EB6805','#404756','#F35683','#B60F52'];
                    res.data.paymentChannelInfos.filter((payItem,payIndex)=>{
                        payItem.color=colors[payIndex];
                        res.data.appPayoutPaymentInfos.filter((item)=>{
                            item.currentPaymentChannelInfos.filter((infoItem,index)=>{
                                if(payItem.paymentChannelDesc===infoItem.paymentChannelDesc){
                                    infoItem.color=payItem.color;
                                }
                            })
                            item.currentPayoutChannelInfos.filter((payoutItem,payoutIndex)=>{
                                if(payItem.paymentChannelDesc===payoutItem.payoutChannelDesc){
                                    payoutItem.color=payItem.color;
                                }
                            })
                        })
                        res.data.payoutChannelInfos.filter((outItem,outIndex)=>{
                            if(payItem.paymentChannelDesc===outItem.payoutChannelDesc){
                                outItem.color=payItem.color;
                            }
                        })
                    })
                    commit('setPaymentChannelInfos',res.data.paymentChannelInfos);  //所有支持的还款渠道信息
                    commit('setPayoutChannelInfos',res.data.payoutChannelInfos);  //所有支持的放款渠道信息
                    resolve(res.data)
                }).catch((e) => {
                    reject(e)
                })
            })
        },
        getModifyPayNum({commit},data){
            commit('setModifyPayNum',data);
        },
        getPayOperateParams({commit},data){
            commit('setPayOperateParams',data);
        },
        getNowPassageway({commit},data){
            commit('setNowPassageway',data);
        },
        getAddPassageway({commit},data){
            commit('setAddPassageway',data);
        },

        getNowPayoutPassageway({commit},data){
            commit('setNowPayoutPassageway',data);
        },
        getAddPayoutPassageway({commit},data){
            commit('setAddPayoutPassageway',data);
        },

        getDeletePassageway({commit},data){
            commit('deletePassageway');
        },
    },
}



// WEBPACK FOOTER //
// ./src/store/payment.js